import { motion, useReducedMotion } from 'framer-motion';

const offsets = {
  up: { y: 28, x: 0 },
  down: { y: -20, x: 0 },
  left: { y: 0, x: 28 },
  right: { y: 0, x: -28 },
  none: { y: 0, x: 0 },
};

export default function Reveal({
  children,
  className,
  as = 'div',
  direction = 'up',
  delay = 0,
  duration = 0.55,
  once = true,
  amount = 0.22,
  style,
}) {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  const offset = offsets[direction] || offsets.up;

  if (reduce) {
    const Tag = as === 'li' ? 'li' : as === 'article' ? 'article' : as === 'section' ? 'section' : 'div';
    return (
      <Tag className={className} style={style}>
        {children}
      </Tag>
    );
  }

  return (
    <MotionTag
      className={className}
      style={style}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
}
